/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';

import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Grid,
  Row,
  Col,
} from 'react-bootstrap';
import Toolbar from 'loracoms/Toolbar';
import Nvl from 'loracoms/Nvl';
import IntlMsg from 'lorautils/intl/IntlMsg';
import DeviceList from './coms/DeviceList';
import GatewayList from './coms/GatewayList';
import AppProps from './coms/AppProps';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  pushState: React.PropTypes.func.isRequired,
  app: React.PropTypes.object.isRequired,
  appId: React.PropTypes.string.isRequired,
  routerAction: React.PropTypes.string.isRequired,
};

class DetailView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      app: props.app,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview');
  }

  componentWillReceiveProps(nextProps) {
    const { app } = nextProps;
    this.setState({ app });
  }

  render() {
    const { appId, routerAction } = this.props;
    const { app } = this.state;
    const { data = {} } = app;

    const breadcrumb = [{
      onClick: () => this.props.pushState('/application'),
      content: this.intlMsg.msg('breadcrumb.application', 'application'),
    }, {
      content: <Nvl val={data.name} status={app.status} />,
      active: true,
    }];

    return (
      <div>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Toolbar breadcrumb={breadcrumb} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <AppProps appId={appId} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <DeviceList appId={appId} routerAction={routerAction} />
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <GatewayList appId={appId} />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}


DetailView.propTypes = propTypes;

const mapStateToProps = (state, ownProps) => ({
  app: state.app.getApp,
  appId: ownProps.params.id,
  routerAction: ownProps.location.action,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DetailView));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/index.jsx